// Provably-dead routine returns at a scalar value slot (spec
// Docs/superpowers/specs/2026-07-19-autocomplete-predicate-head-and-value-slot-function-policy-design.md
// §A2 — the F8 "provably-dead carve-out"). Dead means: no engine accepts the
// call as a scalar comparand against ANY LHS — void/pseudo-type returns
// can't compare, set-returning calls are rejected in WHERE, TVFs aren't
// scalar. Typed returns that are merely INCOMPATIBLE with this LHS stay
// listed (demoted) — F8 still governs those. `undefined`/unrecognized →
// NOT dead (neutral).

const DEAD_EXACT: ReadonlySet<string> = new Set([
  'void', 'trigger', 'event_trigger', 'internal', 'cstring',
  'language_handler', 'fdw_handler', 'index_am_handler', 'tsm_handler',
  'table_am_handler',
  // mssql TVFs — mssqlSchemaIntrospection emits the literal 'table'.
  'table',
]);

export function isDeadRoutineReturn(returns: string | undefined): boolean {
  if (!returns) return false;
  const t = returns.trim().toLowerCase();
  if (DEAD_EXACT.has(t)) return true;
  // pg set-returning spellings from pg_get_function_result.
  return /^setof\s/.test(t) || /^table\s*\(/.test(t);
}
